import React from 'react';
import { CAR_SIZES } from '../utils/carSize';

// The <option>s for a car size <select>. The example cars ride in each option's text — a dropdown
// has the width for it, unlike the phone's chips — and nothing is pre-selected: the forms used to
// default to the first car type, so skipping the field silently chose one.
const CarSizeOptions = () => (
  <>
    <option value="" disabled>Select your car size</option>
    {CAR_SIZES.map((s) => (
      <option key={s.value} value={s.value}>{s.label} — e.g. {s.examples}</option>
    ))}
  </>
);

export default CarSizeOptions;
